// Internal Imports
import { get, post } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const fetchKanbanDocsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.DOCUMENTS}/`)
      .then(res => {
        resolve(res.docs);
      })
      .catch(error => {
        console.error(`kanbanServices => fetchKanbanDocsService => ${error}`);
        reject(error);
      });
  });

export const updateDocumentStatusService = (docId, statusId) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_STATUS}/${docId}/${statusId}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/KanbanActions/kanbanServices.js